<template>
  <div
    ref="donut"
    class="donut"
  >
    <div class="background" />

    <svg>
      <g
        ref="root"
        class="root tooltip-target"
      />
    </svg>
    <transition name="fade">
      <div
        v-if="tooltipData"
        class="custom-tooltip tooltip"
        x-placement="top"
        :style="{ top: tooltipData.top, left: tooltipData.left }"
      >
        <div class="tooltip-arrow" />
        <div class="tooltip-inner">{{ tooltipData.data.name }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
/*

*/
import { interpolate as d3_interpolate } from 'd3-interpolate'
import {
  easeBackOut as d3_easeBackOut,
  easeBackIn as d3_easeBackIn,
  easeCubicInOut as d3_easeCubicInOut,
} from 'd3-ease'
import { select as d3_select } from 'd3-selection'
import { pie as d3_pie, arc as d3_arc,} from 'd3-shape'
import { path as d3_path} from 'd3-path'
import 'd3-transition'

import Size from '../mixins/Size'
// import resize from 'vue-resize-directive'
// import {isBadImgLoaderBrowser} from '@/utils/device'
import {ellipse} from '../utils/textUtils'
export default {
  name: 'PuigDonut',
  // directives:{
  //   resize: resize,
  // },
  mixins: [Size],
  model: {
    prop: 'selection',
    event: 'change',
  },
  props: {
    data: Array,
    selection: Object,
    radiusPercent: {
      default: 0.8,
    },
    showSubs:{
      default: true
    },
    showLabels:{
      default: false
    },
    showTooltips:{
      default: 'auto'
    },
    snapAngle:{
      default: 90
    }
  },
  data() {
    return {
      currentAngle: null, //Starts at null to have propper initial offset until a wedge is selected
      tooltipData: false,
    }
  },
  computed: {
    // size (){
    //   return {width:this.$refs.donut.clientWidth, height: this.$refs.donut.clientHeight}
    // }
  },
  watch: {
    data: function () {
      this.tooltipData = null
      if(!this.data.find((d)=>d.family.id===this.selection?.id)) this.$emit('change', null)
      this.draw()
    },
    selection: function () {
      this.tooltipData = null
      this.draw()
    },
    size: function(){
      this.draw()
    }
  },
  // mounted(){
  //   this.draw()
  // },
  methods: {
    draw() {
      let self = this
      if (!this.$refs.donut) return
      const donutData = JSON.parse(JSON.stringify(this.data))
      
      let rootSel = d3_select(this.$refs.root)

      const width = this.size.width
      const height = this.size.height
      const r = (Math.min(height, width) * this.radiusPercent) / 2
      const innerR = r * 0.3
      const subR = r * 0.6


      var fullArc = d3_arc().innerRadius(innerR).outerRadius(r).padAngle(0.01)
      var subArc = d3_arc().innerRadius(innerR).outerRadius(subR).padAngle(0)
      var mainArc = this.showSubs?d3_arc().innerRadius(subR).outerRadius(r).padAngle(0):fullArc


      var pie = d3_pie()
        .sort(this.compareFamilies)
        .value(function (d) {
          return d.subFamilies.reduce((count, sf) => count + sf.count, 0)
        })
        .startAngle(0)
        .endAngle(2 * Math.PI)

      var arcTween = function (a) {
        let node = this.parentNode
        var i = d3_interpolate(node._current, a)
        node._current = i(0)
        return function (t) {
          return fullArc(i(t))
        }
      }
      var subArcTween = function (a) {
        let node = this.parentNode
        var i = d3_interpolate(node._current, a)
        let r0 = self.showSubs ? subR : innerR
        var ri = d3_interpolate(node._current.data.radius || r0, a.data.radius)
        var ease
        if (node._current.data.radius < a.data.radius) ease = d3_easeBackOut
        else ease = d3_easeBackIn
        node._current = i(0)
        node._current.data.radius = ri(0)
        return function (t) {
          return subArc.outerRadius(ri(ease(t)))(i(t))
        }
      }
      var arcTweenDeep = function (a) {
        let node = this.parentNode.parentNode
        var i = d3_interpolate(node._current, a)
        node._current = i(0)
        return function (t) {
          return fullArc(i(t))
        }
      }

      function findNeighborArc(i, data0, data1, key) {
        var d
        // eslint-disable-next-line
        return (d = findPreceding(i, data0, data1, key))
          ? // eslint-disable-next-line
          { data: d.data, startAngle: d.endAngle, endAngle: d.endAngle }
          : // eslint-disable-next-line
          (d = findFollowing(i, data0, data1, key))
            ? // eslint-disable-next-line
            { data: d.data, startAngle: d.startAngle, endAngle: d.startAngle }
            : null
      }

      // Find the element in data0 that joins the highest preceding element in data1.
      function findPreceding(i, data0, data1, key) {
        var m = data0.length
        // eslint-disable-next-line
        while (--i >= 0) {
          var k = key(data1[i])
          for (var j = 0; j < m; ++j) {
            if (key(data0[j]) === k) return data0[j]
          }
        }
      }

      // Find the element in data0 that joins the lowest following element in data1.
      function findFollowing(i, data0, data1, key) {
        var n = data1.length,
          m = data0.length
        // eslint-disable-next-line
        while (++i < n) {
          var k = key(data1[i])
          for (var j = 0; j < m; ++j) {
            if (key(data0[j]) === k) return data0[j]
          }
        }
      }
      
      
      function showTooltip(d,data,centroidFunction){
        if(self.showTooltips===false) return
        // else if(self.showTooltips==='auto' && !d3_select(this).select('text').select('textPath').node()._ellipsed) return
        let c = centroidFunction({
          startAngle: d.startAngle + self.globalRotation,
          endAngle: d.endAngle + self.globalRotation,
        })
        self.tooltipData = {
          data: data,
          top: c[1] + self.size.height / 2 - self.size.height * 0.05 + 'px',
          left: c[0] + self.size.width / 2 + 'px',
        }
      }
      function hideTooltip(d,data){
        if (self.tooltipData && self.tooltipData.data.id === data.id) self.tooltipData = null
      }
      let donutRoot = d3_select(this.$refs.root)

      let key = d => {
        return d.data.family.id
      }
      let items = donutRoot.selectAll('.item')
      var data0 = items.data(),
        data1 = pie(donutData)

      items = items.data(data1, key)

      let itemsEnter = items.enter().append('g').attr('class', 'item')

      itemsEnter.each(function (d, i) {
        this._current = findNeighborArc(i, data0, data1, key) || {
          data: {},
          startAngle: d.startAngle + (d.endAngle - d.startAngle) / 2,
          endAngle: d.startAngle + (d.endAngle - d.startAngle) / 2,
        }
      })

      itemsEnter
        .append('path')
        .attr('class', 'main-wedge')
        .attr('fill', function (d) {
          return d.data.family.color
        })

      itemsEnter.append('g').attr('class', 'image-container')

      itemsEnter
        .append('clipPath')
        .attr('class', 'clip-path')
        .attr('id', d => {
          return 'donut-clip-' + this._uid + '-' + d.data.family.id
        })
        .append('path')
        .attr('fill', function () {
          return '#000'
        })
      let resizeImage = (selection, duration = 600) => {
        selection.each(function (d) {
          let centroid = fullArc.centroid(d)
          let x = centroid[0]
          let y = centroid[1]
          let theta = Math.atan2(y, x)
          let imageSize = Math.abs(d.endAngle - d.startAngle) > Math.PI ? 3 * r : 3 * r
          x = (Math.cos(theta) * r) / 2 - imageSize / 2
          y = (Math.sin(theta) * r) / 2 - imageSize / 2

          d3_select(this)
            .attr('width', imageSize)
            .attr('height', imageSize)
            .transition()
            .duration(duration)
            .attr('transform-origin', x + imageSize / 2 + ' ' + (y + imageSize / 2))
            .attr('x', x)
            .attr('y', y)
        })
      }
      let instanceId = this._uid
      itemsEnter.each(function (d) {
        const img = document.createElementNS('http://www.w3.org/2000/svg', 'image')
        const href = d.data.family.imageUrl

        img.onload = () => {
          d3_select(this)
            .select('.image-container')
            .append(() => img)
            .call(resizeImage, 0)
          d3_select(this).attr(
            'clip-path',
            'url(#donut-clip-' + instanceId + '-' + d.data.family.id + ')'
          )
        }

        img.onerror = () => {
          d3_select(this).classed('no-image', true)
        }

        if (href) img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', href)

        // BASURA EXPLORER QUE NO DISPARA "onload"...
        // console.log("browser",isBadImgLoaderBrowser)
        // if (isBadImgLoaderBrowser) {
        //   this.timer = setTimeout(()=>{
        //     img.onload()
        //   },400)
        // }
      })
        
      itemsEnter.append('path').attr('class','ghost-wedge').style('opacity',0.35).attr('fill',(d)=>d.data.family.color)
      
      itemsEnter.select('.ghost-wedge').on('click', (e, d) => {
        if (this.selection && this.selection.id === d.data.family.id) self.$emit('change', null)
        else self.$emit('change', d.data.family)
      }).on('mouseenter', function (e, d) {
        showTooltip.call(this,d,d.data.family,mainArc.centroid)
      }).on('mouseout', (e, d) => {
        hideTooltip(d,d.data.family)
      })
      items.exit().remove()
      items = items.merge(itemsEnter)
      // let rawItems = items
      items = items.transition().duration(600)
      items.select('.main-wedge').attrTween('d', arcTween)
      items.select('.clip-path').select('path').attrTween('d', arcTweenDeep)
      items.select('.ghost-wedge').attrTween('d', arcTween)
      items.select('image').call(resizeImage)
             
      ///////////////////////////////////////////

      // SUBWEDGES ...
      let subItems = items.selection().selectAll('.sub-wedge').data(
        d => {
          var subPie = d3_pie()
            .sort(this.compareSubFamilies)
            .value(function (dd) {
              return dd.count
            })
            .startAngle(d.startAngle)
            .endAngle(d.endAngle)

          let sp = subPie(d.data.subFamilies)
          sp.forEach(n => {
            // console.log(d.startAngle)
            n.data.offset = n.startAngle + Math.PI + (n.endAngle - n.startAngle) / 2 //-data1[0].startAngle//+(n.endAngle-n.startAngle)/2
            while (n.data.offset > 2 * Math.PI) n.data.offset -= 2 * Math.PI
            while (n.data.offset < 0) n.data.offset += 2 * Math.PI
            n.data.offset = (50 * n.data.offset) / (2 * Math.PI)
            n.data.radius = this.showSubs ? subR : innerR
            n.data.family = d.data.family //.id
          })

          d.subdata0 = d.subdata1 || []
          d.subdata1 = sp

          return sp
        },
        dd => dd.data.subFamily.id
      )
      let subItemsEnter = subItems.enter().append('g').attr('class', 'sub-wedge')
      subItemsEnter
        .append('path')
        .attr('class', 'sub-wedge-path')
        .attr('d', d => {
          return subArc.outerRadius(() => (this.showSubs ? subR : innerR))(d)
        })
        .attr('opacity', '0')

      subItemsEnter.each(function (d, i) {
        this._current = findNeighborArc(
          i,
          d3_select(this.parentNode).datum().subdata0,
          d3_select(this.parentNode).datum().subdata1,
          (d, i) => i
        ) || {
          data: {},
          startAngle: d.startAngle + (d.endAngle - d.startAngle) / 2,
          endAngle: d.startAngle + (d.endAngle - d.startAngle) / 2,
        }
      })

      subItemsEnter.on('mouseenter', function (e, d) {
        showTooltip.call(this,d,d.data.subFamily,subArc.centroid)
      })
      subItemsEnter.on('mouseout', (e, d) => {
        hideTooltip(d, d.data.subFamily)
      })
      subItemsEnter.on('click', function (e, d) {
        e.stopPropagation()
        d = d3_select(this.parentNode).datum()
        this.tooltipData = null
        if (self.selection && self.selection.id === d.data.family.id) self.$emit('change', null)
        else self.$emit('change', d.data.family)
      })
      
        
      // let subItemsWedgesEnter = subItemsEnter.append('g')
      //   .attr('class','sub-family-wedge')
      //   .attr('opacity',0)
      // subItemsWedgesEnter.append('path')
      //     .attr('class','sub-family-wedge-path')
      // subItemsWedgesEnter.append('text')
      //   .attr('class','sub-family-text')
      //   // .attr('dx',(d)=>-d.data.name.length*3.4)
      //   .append('textPath')
      //     //href={"#text-circle-"+this.instanceId}
      //     // startOffset={(100-textOffset)/2+'%'}
      //     .attr('href',"#text-small-circle-"+this.instanceId)
      //     .attr('alignment-baseline','middle')
      //     .attr("text-anchor","middle")
      //     .attr('startOffset',(d)=>{
      //       // let textOffset = 100*(currentOffset+(family.notes.length-1)/2)*this.props.sdTheta/(2*Math.PI)
      //       return d.data.offset+'%'
      //     })

      // subItemsEnter.append('path')
      //   .attr('class','sub-wedge-selection')
      //   .attr("d", (d)=>{
      //     return smallArcSelection.outerRadius(subR)(d)
      //   })
      //   .attr('stroke','#fff')
      //   .attr('stroke-width',4)
      //   .attr('fill','none')
      //   .attr('opacity','0')

      subItems.exit().remove()

      subItems = subItems.merge(subItemsEnter)
        
      subItems = subItems.transition().duration(600)
      subItems
        .select('.sub-wedge-path')
        // .transition()
        // .duration(700)
        .attrTween('d', subArcTween)
        .attr('opacity', '0.7')
        // .attr('fill',(d)=>Utils.hexToRGB(d.data.color || '#ffffff',0.7))
        .attr('fill', d => {
          return d.data.subFamily.color
        })

      // subItems.select('.sub-wedge-selection')
      //   .attr("d", (d)=>{
      //     return smallArcSelection.outerRadius(subR)(d)
      //   })
      //   .transition()
      //   .attr('opacity',(d)=>{
      //     if(this.showSubs && d.data.id === this.props.subSelection && d.data.family === this.props.selection) return 1
      //     else return 0
      //   })

      // subItems.each(function(d){
      //   if(self.showSubs && d.data.id === self.props.subSelection && d.data.family === self.props.selection) this.parentNode.appendChild(this);
      // })

      // subItems.select('.sub-family-wedge').select('path')
      //   .attr("d", (d) => {
      //     return subArc(d)
      //   })
      //   // .attr('fill','rgba(0,0,0,0.8')
      //   .attr('fill',(d)=>d.data.color)

      // subItems.select('.sub-family-wedge').transition()
      //   .duration(this.showSubs?600:200)
      //   .delay(this.showSubs?600:0)
      //   .attr('opacity',this.showSubs?0.9:0)

      // subItems.select('.sub-family-wedge').select('.sub-family-text').select('textPath')
      //   .text((d,i)=>{
      //     let wedgeLength = (d.endAngle - d.startAngle)*this.subR
      //     let wordLength = d.data.name.length*8
      //     let familyName = wordLength<wedgeLength? d.data.name:d.data.name.substr(0,Math.floor(wedgeLength/8)-1)+'...'
      //     return familyName
      //   })
      //   .transition()
      //   .duration(600)
      //   .attr('startOffset',(d)=>{
      //     return (d.data.offset)+'%'
      //   })
              
      var guideTween = function (a,r) {
        let node = this.parentNode
        var i = d3_interpolate(node._current || a, a)
        node._current = i(0)
        return function (t) {
          let p = d3_path()
          let globalRotation = this.closest('.root')?._globalRotation || 0
          let mid = i(t).startAngle+(i(t).endAngle-i(t).startAngle)/2 + globalRotation
          while(mid<0) mid+=2*Math.PI
          while(mid>2*Math.PI) mid-=2*Math.PI
          let ccw = (mid > Math.PI-Math.PI/2+0.01 && mid < Math.PI+Math.PI/2-0.01)
          if(ccw) p.arc(0, 0, r,  i(t).endAngle-Math.PI/2,i(t).startAngle-Math.PI/2, true)
          else  p.arc(0, 0, r, i(t).startAngle-Math.PI/2, i(t).endAngle-Math.PI/2)
          return p.toString()
        }
      }
      if(this.showLabels){
        itemsEnter.append('path')
          .attr('class','guide')
          .attr('fill','none')
          .attr('pointer-events','none')
          // .attr('stroke','#f00')
          .attr('id',(d)=>d.data.family.id+'-'+this._uid+'-guide')
          
        itemsEnter.append('text').attr('class','main-text')
          .attr('text-anchor','middle')
          .attr('dominant-baseline','middle')
          .style('font-size','24px')
          .style('opacity',0)
          .attr('fill','#fff').append('textPath')
          .attr('href',(d)=>'#'+d.data.family.id+'-'+this._uid+'-guide')
          // .attr('stroke','rgba(0,0,0,0.2)')
          // .attr('stroke-width','6px')
          // .attr('paint-order','stroke')
          .attr('startOffset','50%')
          .text((d)=>d.data.family.name)
          .attr('pointer-events','none')
          
        let labelR = self.showSubs?subR+(r-subR)/2:subR
        items.select('.guide')
          .attrTween('d',function(d){return guideTween.call(this,d,labelR)})
        
        items.selection().select('.main-text').select('textPath')
          .text((d)=>d.data.family.name)
          .each(function(d){
            let maxWidth = labelR*(d.endAngle-d.startAngle)
            ellipse.call(this,maxWidth, 8)
          })
          
        items.select('.main-text').transition().style('opacity',1)
        
          
        let smallLabelR = subR+(innerR-subR)/2
          
        subItemsEnter.append('path')
          .attr('class','sub-guide')
          .attr('fill','none')
          .attr('pointer-events','none')
          .attr('id',(d)=>d.data.family.id+'-'+d.data.subFamily.id+'-'+this._uid+'-sub-guide')
          
        subItemsEnter.append('text').attr('class','sub-text')
          .style('opacity',0)
          .attr('text-anchor','middle')
          .attr('dominant-baseline','middle')
          .style('font-size','18px')
          .attr('fill','#fff').append('textPath')
          // .attr('stroke','rgba(0,0,0,0.07)')
          // .attr('stroke-width','4px')
          // .attr('paint-order','stroke')
          .attr('href',(d)=>'#'+d.data.family.id+'-'+d.data.subFamily.id+'-'+this._uid+'-sub-guide')
          .attr('startOffset','50%')
          .text((d)=>d.data.subFamily.name)
          .attr('pointer-events','none')
          
          
        subItems.select('.sub-guide')
          .attrTween('d',function(d){return guideTween.call(this,d,smallLabelR)})
        

        // subItems.select('text').style('opacity',this.showSubs?1:0)
        subItems.select('text').transition().style('opacity',this.showSubs?1:0)
        
        subItems.selection().select('.sub-text').select('textPath')
          .text((d)=>d.data.subFamily.name)
          .each(function(d){
            let maxWidth = (smallLabelR)*(d.endAngle-d.startAngle)
            ellipse.call(this,maxWidth, 8)
          })
      }
      
      
      items.selection().classed('unselected', d => {
        return self.selection && self.selection.id != d.data.family.id
      })

      let wedge = data1.find(d => {
        return d.data.family.id === self.selection?.id
      })
      
      let dataOffset = -(data1[0].endAngle-data1[0].startAngle)/2
      let offset = (!wedge && this.currentAngle===null) ? dataOffset : Math.PI*this.snapAngle/180
      
      if (wedge) {
        let newAngle = -(wedge.startAngle + (wedge.endAngle - wedge.startAngle) / 2) - Math.PI / 2 // ????? + (this.props.anchorOffset || 0)
        if (!this.currentAngle) {
          this.currentAngle = 0
        }
        while (newAngle - this.currentAngle > Math.PI) {
          newAngle = newAngle - 2 * Math.PI
        }
        while (newAngle - this.currentAngle < -Math.PI) {
          newAngle = newAngle + 2 * Math.PI
        }
        this.currentAngle = newAngle
      }
      
      this.globalRotation = this.currentAngle + offset
      
      //pseudo-enter prevent transition
      if (rootSel.node().getAttribute('transform') === null){
        rootSel.attr(
          'transform',
          `translate(${ width / 2},${ height / 2 }) rotate(${this.globalRotation*180/Math.PI})`
        ) 
      }
      rootSel = rootSel.transition().duration(600).ease(d3_easeCubicInOut)
      
      rootSel.attrTween('globalRotation',function(){
        let i=d3_interpolate(this._globalRotation || 0, self.globalRotation)
        return function(t){
          this._globalRotation = i(t)
        }
      }).attr(
        'transform',
        `translate(${ width / 2},${ height / 2 }) rotate(${this.globalRotation*180/Math.PI})`
      )
    },
  },
}
</script>

<style scoped lang="stylus">
.donut{
  position relative
  // &:after {
  //   content: "";
  //   display: block;
  //   padding-bottom: 100%;
  // }
  .background{
    position absolute;
    top: 0
    left: 0
    width: 100%;
    height: 100%;
    pointer-events all //FOR TESITNG TOOLTIP ONLY
  }
  svg{
    position absolute;
    top: 0
    left: 0
    width: 100%;
    height: 100%;
    pointer-events none
    >>> .item {
      pointer-events all
      cursor pointer
      .sub-wedge-path{
        // pointer-events none
      }
      .image-container{
        pointer-events none
      }
      &.unselected{
        opacity 0.3
      }
    }
  }
  .custom-tooltip {
    position absolute
    transform: translate(-50%,-50%)
    pointer-events none
    transition opacity .6s
    &.fade-enter-active,
    &.fade-leave-active{
      transition: opacity .6s
    }

    &.fade-enter,
    &.fade-leave-to{
      opacity: 0
    }

  }
}
</style>

<style lang="stylus" scoped>
.tooltip
  display: block !important
  z-index: 10000
  // m-font("Lelo", "light")
  // m-font-size(11, 13)
  font-size 11px
  
  .tooltip-inner
    background: black
    text-transform: uppercase
    color #fff
    // border-radius: 16px
    padding: 8px 10px 8px
  .tooltip-arrow
    width: 0
    height: 0
    border-style: solid
    position: absolute
    margin: 5px
    border-color: black
    z-index: 1
  &[x-placement^="top"]
    margin-bottom: 5px
    .tooltip-arrow
      border-width: 5px 5px 0 5px
      border-left-color: transparent !important
      border-right-color: transparent !important
      border-bottom-color: transparent !important
      bottom: -5px
      left: "calc(50% - %s)" % 10px
      margin-top: 0
      margin-bottom: 0
  &[x-placement^="bottom"]
    margin-top: 5px
    .tooltip-arrow
      border-width: 0 5px 5px 5px
      border-left-color: transparent !important
      border-right-color: transparent !important
      border-top-color: transparent !important
      top: -5px
      left: "calc(50% - %s)" % 10px
      margin-top: 0
      margin-bottom: 0
  &[x-placement^="right"]
    margin-left: 5px
    .tooltip-arrow
      border-width: 5px 5px 5px 0
      border-left-color: transparent !important
      border-top-color: transparent !important
      border-bottom-color: transparent !important
      left: -5px
      top: "calc(50% - %s)" % 10px
      margin-left: 0
      margin-right: 0
  &[x-placement^="left"]
    margin-right: 5px
    .tooltip-arrow
      border-width: 5px 0 5px 5px
      border-top-color: transparent !important
      border-right-color: transparent !important
      border-bottom-color: transparent !important
      right: -5px
      top: "calc(50% - %s)" % 10px
      margin-left: 0
      margin-right: 0
  &.popover
    $color = #f9f9f9
    .popover-inner
      background: $color
      color: black
      padding: 24px 24px
      border-radius: 5px
      box-shadow: 0 5px 30px rgba(black, 0.1)
    .popover-arrow
      border-color: $color
  &[aria-hidden='true']
    visibility: hidden
    opacity: 0
    transition: opacity .15s, visibility .15s
  &[aria-hidden='false']
    visibility: visible
    opacity: 1
    transition: opacity .15s</style>